import { useFeatureIsOn as gbUseFeatureIsOn } from '@growthbook/growthbook-react';
import type { TemporaryFlags } from './helpers';

/**
 * Hook for temporary feature flags (experiments, rollouts).
 * These flags should be regularly audited and removed when no longer needed.
 *
 * @returns boolean - whether the flag is enabled
 */
export const useTempFeatureFlag = (flag: keyof TemporaryFlags): boolean => {
  return gbUseFeatureIsOn(flag);
};
